export enum ChallengeLevelEnum {
    first = 1,
    second,
    third
}

export enum EChallengeLevel {
    first = 'اول',
    second = 'دوم',
    third = 'سوم',
}